export default "/_next/static/images/img1-f53c94ea566d6c595e74e332df4a4695.png";